import React from 'react';
import $ from 'jquery'; 
import { ButtonToolbar, ButtonGroup, Button, FormControl, FormGroup, ControlLabel, Grid, Row, Col } from 'react-bootstrap';
import FirstSectionPanel from './FirstSectionPanel.js';
import SecondSectionPanel from './SecondSectionPanel.js';
import ThirdSectionPanel from './ThirdSectionPanel.js';
import { getDozorPlot, getDiffrationThumbnail, getCrystalImage } from '../../../../api/ispyb.js';
import { saveDataCollectionComments } from '../../../../api/ispyb.js';
import ImageZoom from 'react-medium-image-zoom';
import DataCollectionGoupAnalysisToolsPlaceHolder from './DataCollectionGoupAnalysisToolsPlaceHolder.js';


export default class SummaryDataCollectionGroupPanel extends React.Component {
    render() {        
                                                  
        return <Grid fluid style={{marginTop:'15px'}}>                   
                    <Row>
                         <Col xs={12} sm={6} md={4} lg={2}>
                                <FirstSectionPanel processDataCollectionGroup={this.props.processDataCollectionGroup} datacollectiongroup={this.props.datacollectiongroup}></FirstSectionPanel>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={2}>
                                <SecondSectionPanel datacollectiongroup={this.props.datacollectiongroup}></SecondSectionPanel>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={2}>
                                <ThirdSectionPanel
                                        anomalousList = {this.props.datacollectiongroup.anomalousList}
                                        processingStatus = {this.props.datacollectiongroup.processingStatus}
                                        processingPrograms = {this.props.datacollectiongroup.processingPrograms}
                                        processingProgramIds = {this.props.datacollectiongroup.processingProgramIds}
                                        spaceGroups = {this.props.datacollectiongroup.spaceGroups}
                                        scalingStatisticsTypes = {this.props.datacollectiongroup.scalingStatisticsTypes} 
                                        rMerges = {this.props.datacollectiongroup.rMerges} 
                                        completenessList = {this.props.datacollectiongroup.completenessList}
                                        resolutionsLimitHigh = {this.props.datacollectiongroup.resolutionsLimitHigh}
                                        resolutionsLimitLow = {this.props.datacollectiongroup.resolutionsLimitLow}
                                        cells_a = {this.props.datacollectiongroup.cells_a} 
                                        cells_b = {this.props.datacollectiongroup.cells_b} 
                                        cells_c = {this.props.datacollectiongroup.cells_c} 
                                        cells_alpha = {this.props.datacollectiongroup.cells_alpha} 
                                        cells_beta = {this.props.datacollectiongroup.cells_beta} 
                                        cells_gamma = {this.props.datacollectiongroup.cells_gamma} 

                                        ScreeningOutput_indexingSuccess = {this.props.datacollectiongroup.ScreeningOutput_indexingSuccess} 
                                        ScreeningOutput_mosaicity = {this.props.datacollectiongroup.ScreeningOutput_mosaicity} 
                                        ScreeningOutput_strategySuccess = {this.props.datacollectiongroup.ScreeningOutput_strategySuccess} 
                                        summary_datacollection_success = {this.props.datacollectiongroup.summary_datacollection_success} 
                                        ScreeningOutputLattice_spaceGroup = {this.props.datacollectiongroup.ScreeningOutputLattice_spaceGroup} 
                                        ScreeningOutput_rankingResolution = {this.props.datacollectiongroup.ScreeningOutput_rankingResolution} 
                                        ScreeningStrategySubWedge_axisStart = {this.props.datacollectiongroup.ScreeningStrategySubWedge_axisStart} 
                                        ScreeningOutput_totalRotationRange = {this.props.datacollectiongroup.ScreeningOutput_totalRotationRange} 
                                        ScreeningStrategySubWedge_numberOfImages = {this.props.datacollectiongroup.ScreeningStrategySubWedge_numberOfImages} 
                                        ScreeningStrategySubWedge_oscillationRange = {this.props.datacollectiongroup.ScreeningStrategySubWedge_oscillationRange} 
                                        ScreeningStrategySubWedge_transmission = {this.props.datacollectiongroup.ScreeningStrategySubWedge_transmission} 
                                        ScreeningStrategySubWedge_exposureTime = {this.props.datacollectiongroup.ScreeningStrategySubWedge_exposureTime} 

                                        ScreeningOutputLattice_unitCell_a = {this.props.datacollectiongroup.ScreeningOutputLattice_unitCell_a} 
                                        ScreeningOutputLattice_unitCell_b = {this.props.datacollectiongroup.ScreeningOutputLattice_unitCell_b} 
                                        ScreeningOutputLattice_unitCell_c = {this.props.datacollectiongroup.ScreeningOutputLattice_unitCell_c} 
                                        ScreeningOutputLattice_unitCell_alpha = {this.props.datacollectiongroup.ScreeningOutputLattice_unitCell_alpha} 
                                        ScreeningOutputLattice_unitCell_beta = {this.props.datacollectiongroup.ScreeningOutputLattice_unitCell_beta} 
                                        ScreeningOutputLattice_unitCell_gamma = {this.props.datacollectiongroup.ScreeningOutputLattice_unitCell_gamma} 

                                 ></ThirdSectionPanel>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={2}>
                                <ImageZoom   image={{ style: { width: '100%' }, src : getDiffrationThumbnail(this.props.user, this.props.proposal, this.props.datacollectiongroup.lastImageId)}} />
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={2}>
                                <ImageZoom thumbnail image={{ style: { width: '100%' }, src : getCrystalImage(this.props.user, this.props.proposal, this.props.datacollectiongroup.dataCollectionId, 1)}}  />
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={2}>
                                {this.props.configuration.settings.MX.showQualityIndicatorPlot &&
                                        <ImageZoom thumbnail image={{ style: { width: '100%' }, src : getDozorPlot(this.props.user, this.props.proposal, this.props.datacollectiongroup.dataCollectionId)}} />
                                }
                        </Col>
                    </Row>
                    <Row>
                         <Col xs={12} sm={12} md={12} lg={12}>
                                <Comment  dataCollectionGroupId={this.props.datacollectiongroup.dataCollectionGroupId} token={this.props.token} proposal={this.props.proposal} comments={this.props.datacollectiongroup.DataCollectionGroup_comments} ></Comment>                                        
                        </Col>
                    </Row>
                    <Row>
                         <Col xs={12} sm={12} md={12} lg={12}>
                                <DataCollectionGoupAnalysisToolsPlaceHolder 
                                datacollectiongroup={this.props.datacollectiongroup} 
                                jobs={this.props.jobs} 
                                configuration={this.props.configuration}>
                                </DataCollectionGoupAnalysisToolsPlaceHolder>                                        
                        </Col>
                    </Row>
                    
            </Grid>;
    }
}



class Comment extends React.Component {
    constructor(props) {
      super(props);       
      this.state = { 
          changed : false,
          comments : this.props.comments,
          original : this.props.comments          

      }
      this.handleChange = this.handleChange.bind(this);
      this.onSave = this.onSave.bind(this);
      this.onCancel = this.onCancel.bind(this);
    };

   
    onSave(e){
        var _this = this;     
               
        $.ajax({		
                  url:  saveDataCollectionComments(this.props.user, this.props.proposal, this.props.dataCollectionGroupId),		
                  data: {                       
                      "comments" : this.state.comments
                   },		
                  type: "POST",	                                     
                  success: function( data ) {	                      	                   
                        _this.setState({
                                changed : false                
                        });              
                  },			
                  error: function(error) {                       
                       _this.setState({
                                changed : false                
                        }); 
                  }
        });
        

        //DON'T KNOW HOW TO USE AXIOS HERE!!! 
        /*
        axios({
                method: 'POST',
                url: saveDataCollectionComments(this.props.token, this.props.proposal, this.props.dataCollectionGroupId),
                data: {
                      "comments" : this.state.comments   
                },                
                headers: {
                        "Content-Type": 'application/x-www-form-urlencoded'
                }      
        })
        .then(function (response) {        
                _this.setState({
                        changed : false                
                });        
        })
        .catch(function (error) {      
                 _this.setState({
                        changed : true                
                }); 
               
        });*/
    }  

    onCancel(e){
         this.setState({
                  comments : this.state.original,
                  changed : false
          });
    }  
    handleChange(e){
          this.setState({
                  comments : e.target.value,
                  changed : true
          });
    }    
    renderButtons(){
            if (this.state.changed){
                    return <ButtonToolbar>
                        <ButtonGroup bsSize="small">
                        <Button onClick={this.onSave} bsStyle="primary">Save</Button>
                        <Button onClick={this.onCancel} bsStyle="primary">Cancel</Button>      
                </ButtonGroup>
             </ButtonToolbar>
            }
    }
    render() {   
        return <div>
                <FormGroup>
                        <ControlLabel>Comments</ControlLabel>
                        <FormControl onChange={this.handleChange} placeholder="Add a comment" componentClass="textarea" value={this.state.comments}></FormControl>
                </FormGroup>
                {this.renderButtons()}
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/SummaryDataCollectionGroup/SummaryDataCollectionGroupPanel.js